import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPromoList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/stock-promotion/promotion/list?${queries}` });

  return data;
};

export default getPromoList;
